import { css } from '@emotion/react';

export const actionButtonBar = css`
  & .ActionButtonsGroup:empty {
    display: none;
  }

  & > * + *::before {
    content: '';
    display: block;
    width: 1px;
    height: 1.5rem;
    background-color: rgba(0, 0, 0, 0.12);
    margin-left: 0.5rem;
  }
`;
